import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import { TypographyCustomProps } from "../../common/Common.style";
import { HEADER_AND_TAB_HEIGHT } from "../ChatInfo.style";

export const CareTimelineWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 20px;
  gap: 12px;
  max-height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
`;
export const PatientGroupDetailItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DetailItemWrapper = styled(Box)``;

export const DetailItemLabel = styled(Typography)`
  font-size: 14px;
  color: ${theme.palette.grey[700]};
`;

export const DetailItemValue: TypographyCustomProps = styled(Typography)`
  font-size: 15px;
  color: ${theme.palette.grey[900]};
`;

export const AvatarLabel = styled(Typography)`
  font-size: 12px;
  color: ${theme.palette.primary.main};
`;

export const TimelineItemWrapper = styled(Box)``;

export const TimelineItemHeader = styled(Box)`
  display: grid;
  grid-template-columns: auto max-content auto;
  gap: 14px;
  align-items: center;
`;

export const UpdatedAt = styled(Typography)`
  font-size: 14px;
`;

export const TimelineItemDetails = styled(Box)`
  padding: 20px 15px;
  border-radius: 4px;
  box-shadow: 0 0 2px ${theme.palette.grey[400]};
  margin-top: 16px;
`;

export const TemplateFormTitle = styled(Typography)`
  font-size: 14px;
  margin-bottom: 12px;
`;

export const ServiceDetail = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormItemLabel = styled(Typography)`
  font-size: 13px;
  font-weight: 400;
`;

export const Reason = styled(Typography)`
  font-size: 13px;
  margin-right: 5px;
`;

export const PatientGroupDetailsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
